<template>
    <div class="tickets-page">
        <SectionHeader :icon="`icon-ticket_2`">
            {{$t('my tickets') | upperCase}}
        </SectionHeader>
        <div class="mb-4">
            <TicketsTable
                headerIcon="icon-time_sand_watch"
                title="tickets in progress"
                :tickets="activeTickets"
                :headers="activeTableHeaders"
                rowComponent="ActiveTicketRow"
            />
            <div
                v-if="areTicketsLoading && isLoadingActiveTickets"
                class="spinner-container"
            >
                <SpinnerBars />
            </div>
            <CustomButton
                v-if="hasMoreActive"
                @click="getNextActivePage"
                class="btn btn__secondary btn--lg btn--block mt-2"
            >
                {{ $t('load more') | capitalize | upperCase }}
            </CustomButton>
        </div>
        <div class="mb-4">
            <TicketsTable
                headerIcon="icon-check_circle"
                title="resolved tickets"
                :tickets="finishedTickets"
                :headers="resolvedTableHeaders"
                rowComponent="ResolvedTicketRow"
            />
            <div
                v-if="areTicketsLoading && isLoadingFinishedTickets"
                class="spinner-container"
            >
                <SpinnerBars />
            </div>
            <CustomButton
                v-if="hasMoreFinished"
                @click="getNextFinishedPage"
                class="btn btn__secondary btn--lg btn--block mt-2"
            >
                {{ $t('load more') | capitalize | upperCase }}
            </CustomButton>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { TicketsLoadStatus } from '@store/modules/data/tickets/actions';
    import TicketsTable from './components/TicketsTable';

    export default {
        created() {
            this.activeTableHeaders = [
                { title: 'in play', className: 'status' },
                { title: 'played', className: 'played' },
                { title: 'type', className: 'type' },
                { title: 'bet id', className: 'bet-id' },
                { title: 'quote', className: 'coefficient' },
                { title: 'stake', className: 'stake' },
                { title: 'potential win', className: 'payoff' }
            ];
            this.resolvedTableHeaders = [
                { title: 'status', className: 'status' },
                { title: 'played', className: 'played' },
                { title: 'type', className: 'type' },
                { title: 'bet id', className: 'bet-id' },
                { title: 'quote', className: 'coefficient' },
                { title: 'stake', className: 'stake' },
                { title: 'payoff', className: 'payoff' }
            ];
            this.getFirstPage(TicketsLoadStatus.active);
            this.getFirstPage(TicketsLoadStatus.finished);
        },
        computed: {
            ...mapGetters('data/tickets', [
                'areTicketsLoading',
            ]),
            ...mapGetters('ui/ticketsPage', [
                'activeTickets',
                'finishedTickets',
                'hasMoreActive',
                'hasMoreFinished',
                'isLoadingActiveTickets',
                'isLoadingFinishedTickets'
            ]),
        },
        methods: {
            ...mapActions('ui/ticketsPage', [
                'getFirstPage',
                'getNextPage',
            ]),
            getNextActivePage() {
                this.getNextPage(TicketsLoadStatus.active);
            },
            getNextFinishedPage() {
                this.getNextPage(TicketsLoadStatus.finished);
            }
        },
        components: {
            TicketsTable,
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/tickets/TicketsContainer.vue